/* tslint:disable */
 
import { ActionInfo } from './action-info';
import { CommentDataEntryValue } from './comment-data-entry-value';
export class CommentDataEntry {
  creationInfo?: ActionInfo;
  dataEntity: string;
  entityVersion?: number;
  id?: string;
  specificationVersion: number;
  state: 0 | 1 | 2;
  updateInfo?: ActionInfo;
  value: CommentDataEntryValue;
}
